import React from "react";

type Props = {
  children: any;
  title?: string;
  style?: React.CSSProperties;
};

const Card = (props: Props) => {
  return (
    <div className="card" style={props.style}>
      {props.title && (
        <h2 style={{ color: "#6b7fa8", fontWeight: 600 }}>{props.title}</h2>
      )}
      <div style={{ fontSize: 24 }}>{props.children}</div>
    </div>
  );
};

export default Card;
